import { createFileRoute } from '@tanstack/react-router';
import { PerformanceReviewList } from '@/components/company/performance/performance-review-list';

export const Route = createFileRoute('/(app)/company/performance-review/')({
  component: PerformanceReview,
});

function PerformanceReview() {
  return <PerformanceReviewList />;
}
